import { PublicClientApplication, EventType } from "@azure/msal-browser";

const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || "";
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || "";
export const ALLOWED_DOMAIN = process.env.REACT_APP_ALLOWED_EMAIL_DOMAIN || "kif.unizg.hr";

export const SSO_CONFIGURED = Boolean(tenantId && clientId);

export const msalConfig = {
  auth: {
    clientId: clientId || "00000000-0000-0000-0000-000000000000",
    authority: tenantId ? `https://login.microsoftonline.com/${tenantId}` : "https://login.microsoftonline.com/common",
    // Iter75d: switched to REDIRECT flow (from popup flow). Redirect flow is robust
    // across all browsers/modes (InPrivate, strict privacy) because there's no
    // parent-popup cross-window communication — everything happens in one window.
    // redirectUri MUST be a URL that loads the React app (so MSAL library can
    // process handleRedirectPromise() when MS returns with #code=...).
    // /login is public (not behind <Protected>) and Login.jsx handles the response.
    redirectUri: typeof window !== "undefined" ? `${window.location.origin}/login` : "",
    postLogoutRedirectUri: typeof window !== "undefined" ? window.location.origin + "/login" : "",
  },
  cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false },
};

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
  // Iter75: force account picker (shows tenant branding + lets user choose account)
  // instead of silent redirect when user has an active MS session.
  prompt: "select_account",
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Iter75e: eksplicitna handle-redirect-promise pri init da MSAL uhvati #code=... iz URL-a
// PRIJE nego bilo koja React komponenta pokuša. Rezultat se cache-ira interno u MSAL-u.
// Također verbose logging tijekom SSO flow-a — vidljivo u DevTools Console.
msalInstance.initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then((response) => {
    if (response) {
      console.info("[MSAL] handleRedirectPromise resolved with account:", response.account?.username);
    } else {
      const accs = msalInstance.getAllAccounts();
      console.debug("[MSAL] init complete, cached accounts:", accs.length);
    }
    const accs = msalInstance.getAllAccounts();
    if (accs.length > 0) msalInstance.setActiveAccount(accs[0]);
  })
  .catch((err) => {
    console.error("[MSAL] handleRedirectPromise error:", err);
  });

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    console.info("[MSAL] LOGIN_SUCCESS event for", event.payload.account.username);
    msalInstance.setActiveAccount(event.payload.account);
  } else if (event.eventType === EventType.LOGIN_FAILURE) {
    console.error("[MSAL] LOGIN_FAILURE event:", event.error);
  }
});
